import { render, staticRenderFns } from "./addSalesRecords.vue?vue&type=template&id=2ef81b24&scoped=true"
import script from "./addSalesRecords.vue?vue&type=script&lang=js"
export * from "./addSalesRecords.vue?vue&type=script&lang=js"
import style0 from "./addSalesRecords.vue?vue&type=style&index=0&id=2ef81b24&prod&lang=scss"
import style1 from "./addSalesRecords.vue?vue&type=style&index=1&id=2ef81b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef81b24",
  null
  
)

export default component.exports